import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import axios from 'axios'

Vue.use(VueRouter)
Vue.config.productionTip = false

// Configure axios
Vue.prototype.$axios = axios

// Create router instance
const router = new VueRouter({
  mode: 'history',
  routes: []
})

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
